import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls = "w-full rounded-lg border border-terracotta/25 bg-white px-4 py-3 text-encre placeholder:text-taupe/60 focus:outline-none focus:ring-2 focus:ring-terracotta/50";
const labelCls = "block text-sm font-semibold text-encre mb-1.5";

// Créneaux de 30 minutes : 11h30-14h00 et 18h30-22h00
const slots = [];
const addSlots = (startH, startM, endH, endM) => {
  let t = startH * 60 + startM;
  const end = endH * 60 + endM;
  while (t <= end) {
    slots.push(`${String(Math.floor(t / 60)).padStart(2, "0")}h${String(t % 60).padStart(2, "0")}`);
    t += 30;
  }
};
addSlots(11, 30, 14, 0);
addSlots(18, 30, 22, 0);

export const Honeypot = ({ value, onChange }) => (
  <div className="hp-field" aria-hidden="true">
    <label htmlFor="hp-website">Ne pas remplir</label>
    <input id="hp-website" type="text" name="website" tabIndex="-1" autoComplete="off" value={value} onChange={onChange} />
  </div>
);

export const RgpdCheckbox = ({ checked, onChange, idPrefix }) => (
  <div className="flex items-start gap-3">
    <input
      id={`${idPrefix}-rgpd`}
      data-testid={`${idPrefix}-rgpd`}
      type="checkbox"
      required
      checked={checked}
      onChange={onChange}
      className="mt-1 h-4 w-4 accent-terracotta"
    />
    <label htmlFor={`${idPrefix}-rgpd`} className="text-sm text-taupe leading-relaxed">
      J'accepte que mes informations soient utilisées pour traiter ma demande, conformément à la{" "}
      <a href="/politique-de-confidentialite" className="text-terracotta underline underline-offset-2">politique de confidentialité</a>. *
    </label>
  </div>
);

export const ReservationForm = () => {
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);
  const [form, setForm] = useState({
    nom: "", email: "", telephone: "", date: "", heure: "", personnes: 2,
    occasion: "", demandes: "", rgpd: false, website: "",
  });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/reservations`, { ...form, personnes: Number(form.personnes) });
      toast.success(data.message);
      navigate("/merci?type=reservation");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Une erreur est survenue. Veuillez réessayer ou nous appeler au 07 75 77 29 51.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="reservation-form" id="reservation">
      <Honeypot value={form.website} onChange={set("website")} />
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="res-nom" className={labelCls}>Nom et prénom *</label>
          <input id="res-nom" data-testid="reservation-nom" required className={inputCls} value={form.nom} onChange={set("nom")} autoComplete="name" />
        </div>
        <div>
          <label htmlFor="res-email" className={labelCls}>Email *</label>
          <input id="res-email" data-testid="reservation-email" type="email" required className={inputCls} value={form.email} onChange={set("email")} autoComplete="email" />
        </div>
        <div>
          <label htmlFor="res-tel" className={labelCls}>Téléphone *</label>
          <input id="res-tel" data-testid="reservation-telephone" type="tel" required className={inputCls} value={form.telephone} onChange={set("telephone")} autoComplete="tel" />
        </div>
        <div>
          <label htmlFor="res-personnes" className={labelCls}>Nombre de personnes *</label>
          <input id="res-personnes" data-testid="reservation-personnes" type="number" min="1" max="30" required className={inputCls} value={form.personnes} onChange={set("personnes")} />
        </div>
        <div>
          <label htmlFor="res-date" className={labelCls}>Date souhaitée *</label>
          <input id="res-date" data-testid="reservation-date" type="date" required className={inputCls} value={form.date} onChange={set("date")} />
        </div>
        <div>
          <label htmlFor="res-heure" className={labelCls}>Heure souhaitée *</label>
          <select id="res-heure" data-testid="reservation-heure" required className={inputCls} value={form.heure} onChange={set("heure")}>
            <option value="">Choisir un créneau</option>
            {slots.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </div>
      <div>
        <label htmlFor="res-occasion" className={labelCls}>Occasion spéciale (facultatif)</label>
        <input id="res-occasion" data-testid="reservation-occasion" className={inputCls} value={form.occasion} onChange={set("occasion")} placeholder="Anniversaire, repas d'affaires…" />
      </div>
      <div>
        <label htmlFor="res-demandes" className={labelCls}>Demandes particulières (allergies, régimes, terrasse…)</label>
        <textarea id="res-demandes" data-testid="reservation-demandes" rows="3" className={inputCls} value={form.demandes} onChange={set("demandes")} />
      </div>
      <RgpdCheckbox checked={form.rgpd} onChange={set("rgpd")} idPrefix="reservation" />
      <button
        type="submit"
        data-testid="reservation-submit"
        disabled={sending}
        className="rounded-full bg-terracotta text-cream px-8 py-3.5 font-semibold transition-all duration-300 hover:bg-terracotta-dark hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {sending ? "Envoi en cours…" : "Envoyer ma demande de réservation"}
      </button>
    </form>
  );
};
